<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    header="Unable To Publish"
    :style="{ width: '50vw' }">
    <div class="space-y-8">
      <div v-for="error in validationErrors" :key="error.message">
        {{ error.message }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
const emit = defineEmits(['update:visible'])
const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  validationErrors: {
    type: Array,
    required: true
  }
})
</script>
